import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Inject,
  PLATFORM_ID,
  ChangeDetectorRef
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  GlossaryService
} from 'src/app/services/glossary.service';
import {
  SeoService
} from 'src/app/services/seo.service';
import {
  Meta
} from '@angular/platform-browser';
import {
  Glossary
} from 'src/app/models/glossary';
import {
  Router,
  ActivatedRoute,
  RouterModule
} from '@angular/router';
import {
  GlobalService
} from 'src/app/services/global.service';
import {
  ViewportScroller
} from '@angular/common';
import {
  Subscription
} from 'rxjs';

@Component({
    selector: 'app-glossary',
    templateUrl: './glossary.component.html',
    styleUrls: ['./glossary.component.scss'],
    providers: [GlossaryService],
    imports:[RouterModule,CommonModule]
})
export class GlossaryComponent implements OnInit, OnDestroy{
  title = "Investing for Catholics glossary of investing keywords";
  glossarys: Glossary[] = []
  subscriptions: Subscription[] = [];
  alphabeticalLinks = [{
    letter: "#",
    disabled: false,
    anchor: "numbers"
  }]
  alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  constructor(
    private glossaryservice: GlossaryService, 
    private seoservice: SeoService, 
    private meta: Meta, 
    private route: ActivatedRoute, 
    private global: GlobalService, 
    private viewportScroller: ViewportScroller,
    private elRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdr: ChangeDetectorRef
  ) {

  this.subscriptions.push(this.glossaryservice.getGlossary().subscribe(resp => {

      this.glossarys = resp.map((x:Glossary)=>{
        if (/^\d/.test(x.anchor)) {  
          // Add an underscore to the beginning of the anchor  
          return { ...x, anchor: '_' + x.anchor };  
        }  
        return x;
      })

      for (let i = 0; i < this.alphabet.length; i++) {
        var letterFound = false;
        for (var g = 0; g < this.glossarys.length; g++) {

          if (this.glossarys[g].anchor[0] === this.alphabet[i].toLowerCase()) {

            this.alphabeticalLinks.push({
              letter: this.alphabet[i],
              disabled: false,
              anchor: this.glossarys[g].anchor_alphabetical
            });
            letterFound = true;
            break;

          }
        };
        if (!letterFound) {
          // If break doesnt happen term doesn't exist
          this.alphabeticalLinks.push({
            letter: this.alphabet[i],
            disabled: true,
            anchor: null
          });
        }
      }

      setTimeout(()=>{
        this.subscriptions.push(this.route.fragment.subscribe(fragment => {
          // If the Observable has already emitted data, scroll to the target anchor  
          if (this.glossarys != null) {
            this.scrollToAnchor(fragment);
            this.cdr.detectChanges();
          }
        }));
      },200)

    }));
  }
  ngOnDestroy(): void {
     this.subscriptions.forEach(sub => {
       sub.unsubscribe();
     });
  }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
    this.meta.addTag({
      name: 'keywords',
      content: 'investing glossary, investing for catholics glossary, investing keywords'
    });
    this.meta.addTag({
      name: 'description',
      content: 'A glossary of commonly used keywords in the investing world.'
    });
    this.meta.addTag({
      name: 'author',
      content: 'Investing for Catholics'
    });
    this.meta.addTag({
      name: 'robots',
      content: 'index, follow'
    });
  }


  private scrollToAnchor(fragment: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const targetElement = this.elRef.nativeElement.querySelector(`#${fragment}`);
    const menuHeight = document.querySelector("nav.navbar")?.getBoundingClientRect().height || 0; // Replace with the actual menu height  
    const fixedTopNav = document.querySelector(".fixedTopNav")?.getBoundingClientRect().height || 0;
    

    if (targetElement) {  
      const targetPosition = targetElement.parentElement.getBoundingClientRect().top - (menuHeight+fixedTopNav)-5;  
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });  
    }  
  }

}